import React from 'react';
import { useT } from '@repo/common';
import HeaderText from '../Common/HeaderText';
import PaymentsHeaderButton from './PaymentHeaderButton';

const PaymentsHeader = ({ currentFilter, onFilterChange, $isMobile }) => {
  const t = useT();

  return (
    <div className='flex w-full items-start justify-between tabletH:px-[15px]'>
      {!$isMobile && <HeaderText label={t('Payment history', '결제 내역')} />}
      {$isMobile && <div></div>}
      <div className='w-full pb-4 tabletH:w-auto tabletH:pb-0'>
        <PaymentsHeaderButton
          currentFilter={currentFilter}
          onFilterChange={onFilterChange}
        />
      </div>
    </div>
  );
};

export default PaymentsHeader;
